import { useSnackbar } from 'notistack'

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ message, variant, preventDuplicate = true }) {
  const { enqueueSnackbar,  } = useSnackbar()
  enqueueSnackbar(message, {
    variant,
    preventDuplicate,
  });
}